import { RESET_STATE } from 'store/global/actions';

import { LOAN_FEE_REASON_HISTORY_ACTION_TYPE } from '../actions';

const initialState = {};

const loanFeeReasonHistoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_FEE_REASON_HISTORY_ACTION_TYPE.GET_LOAN_FEE_REASON_HISTORY:
      return payload?.cicChangeDetails || initialState;

    case LOAN_FEE_REASON_HISTORY_ACTION_TYPE.EDIT_LOAN_FEE_REASON_HISTORY:
      return payload?.cicChangeDetails || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanFeeReasonHistoryReducer;
